import InputPhoneNumberModal from './InputPhoneNumberModal';

export default InputPhoneNumberModal;
